import { createContext, useContext } from 'react';
import type { VclClampNote, VclControlId, VclControlState } from './types.js';

export interface VclContextValue {
  readonly enabled: boolean;
  readonly state: VclControlState;
  readonly effectiveState: VclControlState;
  readonly clamps: readonly VclClampNote[];
  readonly setControl: (id: VclControlId, step: number) => void;
  readonly resetToBaseline: () => void;
  readonly exportPromotionJson: () => string;
}

export const VclContext = createContext<VclContextValue | null>(null);

export function useVcl(): VclContextValue {
  const ctx = useContext(VclContext);
  if (ctx === null) {
    throw new Error('useVcl must be used within VclProvider');
  }
  return ctx;
}

/** Safe hook when provider may be absent (prod / VCL off). */
export function useVclOptional(): VclContextValue | null {
  return useContext(VclContext);
}